import BaseComponentController from "../base_component_controller"

export default class extends BaseComponentController {
  static targets = ['input', 'filesContainer', 'fileInputGroupTemplate']

  static values = {
    forceFilesOverride: { type: Boolean, default: false }
  }

  connect() {
    this.files = []
    this.formFileInputGroupIdentifier = 'design-system--form--file-input-group-component'
  }

  triggerInput(event) {
    event?.preventDefault()
    this.inputTarget.click()
  }

  handleInputChange(event) {
    this.dispatchEvent({ action: 'before-change' })

    if (this.forceFilesOverrideOnChange) {
      this.reset()
    }

    Array.from(event.target.files).forEach(file => this.addFile(file))

    this.dispatchEvent({ action: 'after-change' })
  }

  addFile(file) {
    this.files.push(file)
    this.transferFilesToInput()

    const element = this.fileInputGroupTemplateTarget.content.cloneNode(true).firstElementChild
    this.filesContainerTarget.appendChild(element)

    element.addEventListener(`${this.formFileInputGroupIdentifier}:connected`, (e) => {
      this.dispatchEvent({ target: e.currentTarget, action: 'file-added', options: { detail: { file } } })
    })

    element.addEventListener(`${this.formFileInputGroupIdentifier}:after-remove-file`, (e) => {
      this.removeFile(e.detail.file)
    })
  }

  removeFile(file) {
    this.files = this.files.filter(f => f.name !== file.name)
    this.transferFilesToInput()
  }

  transferFilesToInput() {
    const dt = new DataTransfer()
    Array.from(this.files).forEach(file => dt.items.add(file))
    this.inputTarget.files = dt.files
  }

  reset() {
    this.files = []
    this.filesContainerTarget.innerHTML = ''
  }

  get forceFilesOverrideOnChange() {
    return this.forceFilesOverrideValue
  }
}
